// extracted by mini-css-extract-plugin
export default {"toggle":"oNCyh6","checked":"MNPdqT","icon":"hexrun"};